// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1856":"3aead578","2040":"267eece7","3043":"6f6dc9be","3101":"26c08faa","4364":"31cbfa12","9760":"26c08faa"}[chunkId] + ".chunk.css";
};